{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Изберете предмет",
  "tableResizer": "Преоразмерител"
}
